<div *ngIf="showBanners" class="container-large">
  <div class="section-header short-line">
    <h2 class="section-title">{{this.word[this.language].recommended}}</h2>
  </div>
  <div class="slider topical-slider first-topical">
    <ngx-skeleton-loader *ngIf="!contentLoaded" count="1" animation="progress" [theme]="{
    display: 'block',
    'border-radius': '6px',
    'margin-bottom': '0px',
    'background-color': '#c8c8c8',
    'height' : '130px'
  }"></ngx-skeleton-loader>

    <!-- <swiper [navigation]="{ prevEl: prevEl, nextEl: nextEl }"  [lazy]="true" [slidesPerView]="1" [updateOnWindowResize]="false"
      [spaceBetween]="20" [breakpoints]="{
    '320': {
      slidesPerView: '1.1',
      spaceBetween: 10
    },
    '580': {
      slidesPerView: '2',
      centeredSlides: true,
      spaceBetween: 10
    },
    '768': {
      slidesPerView: '3',
      spaceBetween: 10
    },
    '991': {
      slidesPerView: '4'
    },
    '1280':{
      slidesPerView: '4.5',
      loopAdditionalSlides: 6
    }
  }">


      <ng-template swiperSlide *ngFor="let banner of recommendedBanners" class="recommended-slide">
        <a class="topical-img-link" href="{{language == 'en' ? banner?.link_en : banner?.link}}" [attr.aria-label]="[this.language == 'bg' ? 'Този линк води към ' : 'This links leads to ' +  banner.criteria]">
          <img [attr.title]="banner.criteria" loading="lazy" widht="268px" height="129px" class="topical-img" src="{{banner.PictureFullUrl}}" alt="Small banner of a topical category">
        </a>
      </ng-template>
    </swiper> -->
    <swiper-container init="false" #recommendedSlider appSwiper [config]="this.config">
      <swiper-slide  *ngFor="let banner of recommendedBanners" class="recommended-slide">
        <a class="topical-img-link" href="{{language == 'en' ? banner?.link_en : banner?.link}}" [attr.aria-label]="[this.language == 'bg' ? 'Този линк води към ' : 'This links leads to ' +  banner.criteria]">
          <img [attr.title]="banner.criteria" loading="lazy" widht="268px" height="129px" class="topical-img" src="{{banner.PictureFullUrl}}" alt="Small banner of a topical category">
        </a>
      </swiper-slide>
    </swiper-container>
    <div class="swiper-navigation">
      <button type="button" id="prev-rec" class="swiper-arrows swiper-navigation-prev" aria-label="Go to next slide"><i
          class="fa fa-chevron-left" aria-hidden="true"></i></button>
      <button type="button" id="next-rec" class="swiper-arrows swiper-navigation-next" aria-label="Go to previous slide"><i
          class="fa fa-chevron-right" aria-hidden="true"></i></button>
    </div>
  </div>
</div>
